import React from 'react';
import classnames from 'classnames';
import pathfinder from '@fiverr-private/pathfinder';
import FiverrLogo from '@fiverr-private/icons/logos/fiverr_logo_nav';

import { LOGO_BASE_CLASS } from '../../constants';

import './style.scss';

const Logo = () => (
    <a href={pathfinder('root')} className={classnames(LOGO_BASE_CLASS, 'logo')}>
        <FiverrLogo />
    </a>
);

export default Logo;
